///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const DeleteIcon = ({
  height,
  title = messages.delete.defaultMessage,
  width,
  fill = "#343434",
  ...rest
}) => (
  <svg
    aria-labelledby="delete-icon"
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="delete-icon">{title}</title>
    <path
      d="M.875 4.375v8.75c0 .481.394.875.875.875h7.875a.878.878 0 00.875-.875v-8.75H.875zM3.5 12.25h-.875V6.125H3.5v6.125zm1.75 0h-.875V6.125h.875v6.125zm1.75 0h-.875V6.125H7v6.125zm1.75-6.125v6.125h-.875V6.125h.875zM7.219 0c.36 0 .656.295.656.656V1.75h2.844c.36 0 .656.295.656.656V3.5H0V2.406c0-.36.295-.656.656-.656H3.5V.656c0-.36.295-.656.656-.656z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);
export default DeleteIcon;
